export default function AttachFindingReportFolderController(
  $rootScope,
  $scope,
  $q,
  $filter,
  $timeout,
  ssDialogService,
  loaderService,
  alerts,
  userService,
  amDataService
) {
  const vm = this;

  vm.canExpand = vm.status !== 'No Reports Added';
  vm.isExpanded = false;
  vm.reportInstancesLoaded = false;
  vm.handleExpandFolder = _handleExpandFolder;

  function _handleExpandFolder() {
    vm.isExpanded = !vm.isExpanded;

    if (vm.isExpanded) {
      _refreshReportInstances();
    }
  }

  function _refreshReportInstances() {
    const dfdRefresh = $q.defer();

    if (!vm.reportInstancesLoaded) {
      vm.reportInstances = vm.reportFolder.reportInstances;

      if ((vm.reportInstances !== null) && (vm.reportInstances.length > 0)) {
        amDataService.getFindingReportsByFinding(vm.findingId).then((getAssignedReportsResponse) => {
          const assignedReports = getAssignedReportsResponse.data.result;
          if (assignedReports.length > 0) {
            assignedReports.forEach((assignedReport) => {
              vm.reportInstances.forEach((report) => {
                if ((report.reportInstanceId === assignedReport.reportInstanceId)
                  && (assignedReport.findingId === vm.findingId)) {
                  report.findingReportInstanceId = assignedReport.findingReportInstanceId;
                  report.attached = true;
                }
              });
            });
          }
        });
      }

      vm.reportInstancesLoaded = true;
    }

    dfdRefresh.resolve();

    return dfdRefresh.promise;
  }
}

AttachFindingReportFolderController.$inject = [
  '$rootScope',
  '$scope',
  '$q',
  '$filter',
  '$timeout',
  'ssDialogService',
  'loaderService',
  'alerts',
  'userService',
  'amDataService'
];
